import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { listApprovedThemes } from "@/lib/themes-public.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/yapay-zeka-toplum")({
  head: () => ({
    meta: [
      { title: pageTitle("Yapay Zekâ & Toplum", "tr") },
      { name: "description", content: "Yapay zekâ, etik ve güven üzerine denemeler: algoritmik karar, dikkat ekonomisi, emek ve toplumu yeniden şekillendiren sistemlerin eleştirel okuması." },
      { property: "og:title", content: "Yapay Zekâ & Toplum — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: "Yapay zekâ, etik ve toplum üzerine denemeler." },
      { property: "og:url", content: "https://akillisurdurulebilirlik.com/yapay-zeka-toplum" },
      { property: "og:locale", content: "tr_TR" },
      { property: "og:locale:alternate", content: "en_US" },
    ],
    links: [
      { rel: "canonical", href: "https://akillisurdurulebilirlik.com/yapay-zeka-toplum" },
      ...hreflangLinks("/yapay-zeka-toplum", "/ai-society"),
    ],
  }),
  loader: async () => {
    const [posts, themes] = await Promise.all([getAllPosts(), listApprovedThemes()]);
    return { posts, themes };
  },
  component: Page,
});

function Page() {
  const { t } = useT();
  const data = Route.useLoaderData();
  const { articles: posts } = useLocalizedPosts(data.posts);
  return (
    <CategoryPage
      themes={data.themes}
      category={t("cat.ai.title")}
      tagline={t("cat.ai.tagline")}
      essays={posts.filter((p) => String(p.category) === "AI & Society" || String(p.category) === "Yapay Zekâ & Toplum")}
    />
  );
}
